import { render, staticRenderFns } from "./RaceTableColumns.vue?vue&type=template&id=356cb529"
import script from "./RaceTableColumns.vue?vue&type=script&lang=js"
export * from "./RaceTableColumns.vue?vue&type=script&lang=js"
import style0 from "./RaceTableColumns.vue?vue&type=style&index=0&id=356cb529&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports